module.exports = __webpack_public_path__ + "img/114.14c717fc.jpg";